export type AuthErrorCode =
  | 'rate_limit'
  | 'missing_credentials'
  | 'google_account'
  | 'invalid_credentials'
  | 'user_not_found'
  | 'unauthorized'
  | 'impersonation_not_found'
  | 'google_verification_failed'
  | 'google_email_missing'
  | 'invalid_email'
  | 'weak_password'
  | 'username_length'
  | 'duplicate'
  | 'invalid_reset_link'
  | 'unknown'

const AUTH_ERROR_MAP: Array<{ pattern: RegExp; code: AuthErrorCode; message: string }> = [
  { pattern: /çok fazla deneme yaptınız/i, code: 'rate_limit', message: 'Too many attempts. Please try again later.' },
  { pattern: /kullanıcı adı veya şifre boş olamaz/i, code: 'missing_credentials', message: 'Username and password are required.' },
  { pattern: /bu hesap google ile kayıtlı/i, code: 'google_account', message: 'This account uses Google sign-in. Please continue with Google.' },
  { pattern: /kullanıcı adı veya şifre hatalı/i, code: 'invalid_credentials', message: 'Incorrect username or password.' },
  { pattern: /böyle bir kullanıcı yok/i, code: 'user_not_found', message: 'No account found with these credentials.' },
  { pattern: /bu işlem için yetkiniz yok/i, code: 'unauthorized', message: 'You are not authorized to perform this action.' },
  { pattern: /taklit edilecek kullanıcı bulunamadı/i, code: 'impersonation_not_found', message: 'The impersonation target user could not be found.' },
  { pattern: /google doğrulaması başarısız/i, code: 'google_verification_failed', message: 'Google sign-in verification failed. Please try again.' },
  { pattern: /google hesabından email alınamadı/i, code: 'google_email_missing', message: 'Could not read an email from your Google account.' },
  { pattern: /geçerli bir email giriniz/i, code: 'invalid_email', message: 'Please enter a valid email address.' },
  { pattern: /daha güçlü bir şifre giriniz/i, code: 'weak_password', message: 'Please use a stronger password (8+ chars, upper/lowercase, number, symbol).' },
  { pattern: /k\.\s*adı çok 5 ile 24 karakter arası olabilir/i, code: 'username_length', message: 'Username must be between 5 and 24 characters.' },
  { pattern: /bu kullanıcı adı veya email alınmış/i, code: 'duplicate', message: 'This username or email is already in use.' },
  { pattern: /geçersiz veya süresi dolmuş şifre sıfırlama bağlantısı/i, code: 'invalid_reset_link', message: 'This password reset link is invalid or has expired.' },
]

function normalizeAuthErrorMessage(errorMessage: string): string {
  return errorMessage
    .replace(/^GraphQL error:\s*/i, '')
    .replace(/^ApolloError:\s*/i, '')
    .trim()
}

function findAuthError(errorMessage?: string | null) {
  if (!errorMessage) {
    return null
  }

  const normalized = normalizeAuthErrorMessage(errorMessage)
  return AUTH_ERROR_MAP.find(({ pattern }) => pattern.test(normalized)) ?? null
}

export function getAuthErrorCode(errorMessage?: string | null): AuthErrorCode | null {
  if (!errorMessage) {
    return null
  }

  return findAuthError(errorMessage)?.code ?? 'unknown'
}

export function toEnglishAuthError(errorMessage?: string | null): string | null {
  if (!errorMessage) {
    return null
  }

  const normalized = normalizeAuthErrorMessage(errorMessage)
  const mapped = findAuthError(errorMessage)
  return mapped ? mapped.message : normalized
}
